<template>
    <div class="cta-single-banner section-gap pt-0">
        <div class="container">
            <div class="cta text-center align-center">
                <div class="overlay-section-overlay cta-image">
                    <img v-lazyload data-src="static/images/bg-sunglass.jpg" alt="banner-image" />
                    <div class="cta-content">
                        <h5 class="white--text">
                            "El sistema de Sislii me permite cumplir con los procesos de mi negocio en muy pocos pasos"
                        </h5>
                        <h5 class="font-weight-bold mb-6 white--text">Eduardo Lopez | Dueño de Pastelería Edu</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import lazyload from 'Directives/lazyload';
export default {
    directives: {
        lazyload,
    },
};
</script>
